import { getFilterOptions, getPlayers } from '../../../api';
import { onRequest } from '../..';
import { ActionsType, PropertyType } from '../../../common';
import { getFiltersUrl } from '../../../view/pages/PlayerList/PlayerList.helper';

const playersInit = async (payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { players, pagesTotal } = await getPlayers({
		token,
		page,
		query: '',
		perPage,
	});

	return {
		playersLoading: false,
		players: players,
		pagesTotal,
		currentPage: page,
	};
};

const partnersInit = (user: PropertyType) => {
	const { partners } = user;

	return { partners };
};

const filtersInit = async (payload: PropertyType) => {
	const { token, filters } = payload;
	const resp = await getFilterOptions({ token, filters });

	return { ...resp.data };
};

const filterData = async (token: string, page: string, filters: PropertyType[], perPage: string) => {
	const query = filters.length ? getFiltersUrl(filters) : '';
	const { players, pagesTotal } = await getPlayers({
		token,
		page,
		query,
		perPage,
	});

	return {
		playersLoading: false,
		players: players,
		filters,
		pagesTotal,
		filtering: filters.length > 1,
		currentPage: page,
	};
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters } = payload;

	return filterData(token, page, filters, state.perPage);
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, perPage } = payload;
	return filterData(token, page, state.filters, perPage);
};

const onUpdateColumns = async (payload: PropertyType) => {
	const rawValue = JSON.stringify(payload);
	localStorage.setItem('playersList', rawValue);
	return { columns: payload };
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ playersLoading: payload }),
	FILTERS_INIT: (state, payload) => onRequest(() => filtersInit(payload)),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	PLAYERS_INIT: (state, payload) => playersInit(payload),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	INIT_COLUMNS: (state, payload) => ({
		columns: payload.columns,
		initialColumns: payload.initialColumns,
	}),
	UPDATE_COLUMNS: (state, payload) => onUpdateColumns(payload),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	FILTER: (state, payload) => onFilter(state, payload),
	UPDATE_FILTERS: (state, payload) => ({ filters: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', playersLoading: false }),
};
